<template>
  <div class="relative">
    <button @click.stop="toggleMenu" class="text-action text-xl p-0.5 rounded-full rotate-90">
      <i class="fas fa-ellipsis-v"></i>
    </button>
    
    <div v-if="isOpen" 
      class="absolute right-0 mt-0.5 w-[180px] rounded-xl bg-white shadow-lg z-50"
      v-click-outside="closeMenu">
      <div class="py-1" role="menu" aria-orientation="vertical">
        <slot name="options"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { vClickOutside } from '@/directives/clickOutside';

const isOpen = ref(false);

const toggleMenu = () => {
  isOpen.value = !isOpen.value;
};

const closeMenu = () => {
  isOpen.value = false;
};
</script>
